<template>

  <v-card class="ma-3" outlined>
    <v-card-text class="pa-1">
      <v-row no-gutters>
        <v-text-field v-model="c_query" class="ma-1" outlined dense hide-details clearable label="Cauta" background-color="white" prepend-inner-icon="mdi-magnify"/>
        <v-divider vertical class="ma-1"/>
        <div class="ma-1">
          <v-btn depressed color="create white--text" block height="40" @click="$emit('create')">
            <v-icon left>mdi-plus</v-icon>
            Adaugă
          </v-btn>
        </div>
      </v-row>
    </v-card-text>
  </v-card>

</template>

<script>
  export default {
    computed: {
      c_query: {
        get() {
          return this.query;
        },
        set(val) {
          this.$emit("update:query", val);
        }
      }
    },
  }
</script>